import { BlokProps, withStoryblokEditable } from "@helpers/StoryblokHelpers"
import { CooperationPartnersTypePageStoryblok, VaccineTypeStoryblok } from "@storyblok-types"
import { StoryblokServerComponent } from "@storyblok/react/rsc"
import PageContainer from "@ui-library/layout/PageContainer"

interface CooperationPartnersTypePageProps {
  blok: BlokProps<CooperationPartnersTypePageStoryblok>["blok"]
  vaccines: VaccineTypeStoryblok[]
}

export const CooperationPartnersTypePage = ({ blok, vaccines }: CooperationPartnersTypePageProps) => {
  return (
    <PageContainer background={blok.background} extraHeight={false} {...withStoryblokEditable(blok)}>
      {blok.body.map(nestedBlok => (
        <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} vaccines={vaccines} />
      ))}
    </PageContainer>
  )
}

export default CooperationPartnersTypePage
